import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Portfolio } from './pages/Portfolio';
import { CaseStudy1 } from './pages/CaseStudy1';
import { CaseStudy2 } from './pages/CaseStudy2';
import { CaseStudy3 } from './pages/CaseStudy3';
import { CaseStudy5 } from './pages/CaseStudy5';
import { CaseStudy6 } from './pages/CaseStudy6';
import { CaseStudy9 } from './pages/CaseStudy9';
import { SitemapPage } from './pages/SitemapPage';
import { SitemapXML } from './pages/SitemapXML';
import { NotFound } from './pages/NotFound';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { PageTitle } from './components/PageTitle';
export function App() {
  return <HelmetProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <PageTitle data-id="element-2" />
        <div className="flex flex-col min-h-screen bg-white" data-id="element-3">
          <Header data-id="element-4" />
          <main className="flex-grow" data-id="element-5">
            <Routes data-id="element-6">
              <Route path="/" element={<Home data-id="element-8" />} data-id="element-7" />
              <Route path="/portfolio" element={<Portfolio data-id="element-10" />} data-id="element-9" />
              <Route path="/about" element={<About data-id="element-12" />} data-id="element-11" />
              <Route path="/contact" element={<Contact data-id="element-14" />} data-id="element-13" />
              <Route path="/case-study-1" element={<CaseStudy5 data-id="element-16" />} data-id="element-15" />
              <Route path="/case-study-2" element={<CaseStudy9 data-id="element-18" />} data-id="element-17" />
              <Route path="/case-study-3" element={<CaseStudy1 data-id="element-20" />} data-id="element-19" />
              <Route path="/case-study-4" element={<CaseStudy6 data-id="element-22" />} data-id="element-21" />
              <Route path="/case-study-5" element={<CaseStudy3 data-id="element-24" />} data-id="element-23" />
              <Route path="/case-study-6" element={<CaseStudy2 data-id="element-26" />} data-id="element-25" />
              <Route path="/sitemap" element={<SitemapPage data-id="element-28" />} data-id="element-27" />
              <Route path="/sitemap.xml" element={<SitemapXML data-id="element-30" />} data-id="element-29" />
              <Route path="/terms" element={<TermsAndConditions data-id="element-32" />} data-id="element-31" />
              <Route path="/privacy" element={<PrivacyPolicy data-id="element-34" />} data-id="element-33" />
              <Route path="*" element={<NotFound data-id="element-36" />} data-id="element-35" />
            </Routes>
          </main>
          <Footer data-id="element-37" />
        </div>
      </BrowserRouter>
    </HelmetProvider>;
}